import { configureStore } from '@reduxjs/toolkit';
import { authApi } from '@api/authApi';
import { baseApi } from '@api/baseApi';
import { globalSlice } from '@store/global/slice';
import { advancedErrorsSlice } from '@features/advanced-errors/store/slice';
import { ordersSlice } from '@pages/orders/store/slice';
import { previewSlice } from '@pages/preview/store/slice';
import { filterSlice } from '@pages/filter/store/slice';
import { reportingRedatedSlice } from '@pages/reporting-pages/redated-orders/store/slice';
import { reportingReducedSlice } from '@pages/reporting-pages/reduced-orders/store/slice';
import { reportingReducedMaterialsSlice } from '@pages/reporting-pages/reduced-materials/store/slice';
import { reportingShipmentStopsSlice } from '@pages/reporting-pages/shipment-stops/store/slice';
import { reportingUndeliveredSlice } from '@pages/reporting-pages/undelivered-orders/store/slice';
import { reportingDeliveriesMainSlice } from '@pages/reporting-pages/deliveries-main/store/slice';
import { reportingDeliveriesTradesDcSlice } from '@pages/reporting-pages/deliveries-trades-dc/store/slice';
import { reportingDeliveriesTradesDistrictSlice } from '@pages/reporting-pages/deliveries-trades-district/store/slice';
import { reportingDeliveriesCustomerSlice } from '@pages/reporting-pages/deliveries-customer/store/slice';
import { reportingDeliveriesSkuSlice } from '@pages/reporting-pages/deliveries-sku/store/slice';
import { reportingDeliveriesSkuDcSlice } from '@pages/reporting-pages/deliveries-sku-dc/store/slice';
import { reportingDeliveriesSkuDistrictSlice } from '@pages/reporting-pages/deliveries-sku-district/store/slice';
import apiErrorLogger from '@features/advanced-errors/middlewares/apiErrorLogger';
import { authMiddleware } from '@features/authentication/authMiddleware';



export const store = configureStore({
	reducer: {
		[globalSlice.reducerPath]: globalSlice.reducer,
		[advancedErrorsSlice.reducerPath]: advancedErrorsSlice.reducer,
		[ordersSlice.reducerPath]: ordersSlice.reducer,
		[previewSlice.reducerPath]: previewSlice.reducer,
		[filterSlice.reducerPath]: filterSlice.reducer,
		[reportingRedatedSlice.reducerPath]: reportingRedatedSlice.reducer,
		[reportingReducedSlice.reducerPath]: reportingReducedSlice.reducer,
		[reportingReducedMaterialsSlice.reducerPath]: reportingReducedMaterialsSlice.reducer,
		[reportingUndeliveredSlice.reducerPath]: reportingUndeliveredSlice.reducer,
		[reportingShipmentStopsSlice.reducerPath]: reportingShipmentStopsSlice.reducer,
		[reportingDeliveriesMainSlice.reducerPath]: reportingDeliveriesMainSlice.reducer,
		[reportingDeliveriesTradesDcSlice.reducerPath]: reportingDeliveriesTradesDcSlice.reducer,
		[reportingDeliveriesTradesDistrictSlice.reducerPath]: reportingDeliveriesTradesDistrictSlice.reducer,
		[reportingDeliveriesCustomerSlice.reducerPath]: reportingDeliveriesCustomerSlice.reducer,
		[reportingDeliveriesSkuSlice.reducerPath]: reportingDeliveriesSkuSlice.reducer,
		[reportingDeliveriesSkuDcSlice.reducerPath]: reportingDeliveriesSkuDcSlice.reducer,
		[reportingDeliveriesSkuDistrictSlice.reducerPath]: reportingDeliveriesSkuDistrictSlice.reducer,
		[authApi.reducerPath]: authApi.reducer,
		[baseApi.reducerPath]: baseApi.reducer,
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware()
		.concat(authApi.middleware)
		.concat(baseApi.middleware)
		.concat(authMiddleware)
		.concat(apiErrorLogger)
});



export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;